var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.route !== null
    ? _c(
        "div",
        [
          !_vm.children
            ? _c(
                "el-menu-item",
                {
                  staticClass: "headMenu",
                  class: { "submenu-title-noDropdown": !_vm.isNest },
                  attrs: { disabled: true, index: _vm.route.path }
                },
                [
                  _vm.route.meta && _vm.route.meta.title
                    ? _c("svg-icon", {
                        attrs: { "icon-class": _vm.route.meta.icon }
                      })
                    : _vm._e(),
                  _vm.route.meta && _vm.route.meta.title
                    ? _c("span", [_vm._v(_vm._s(_vm.route.meta.title))])
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "menu-wrapper  pms_menu" },
            [
              _vm._l(_vm.routes, function(item) {
                return !item.hidden
                  ? [
                      !item.children
                        ? _c(
                            "router-link",
                            {
                              key: item.name,
                              attrs: {
                                to:
                                  _vm.route.path +
                                  "/" +
                                  item.path +
                                  (item.props !== undefined
                                    ? "?" + _vm.getQuery(item.props)
                                    : "")
                              }
                            },
                            [
                              _c(
                                "el-menu-item",
                                {
                                  class: {
                                    "submenu-title-noDropdown": !_vm.isNest
                                  },
                                  attrs: {
                                    index: _vm.route.path + "/" + item.path
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleRouteLink(item)
                                    }
                                  }
                                },
                                [
                                  item.meta && item.meta.icon
                                    ? _c("svg-icon", {
                                        attrs: { "icon-class": item.meta.icon }
                                      })
                                    : _vm._e(),
                                  item.meta && item.meta.title
                                    ? _c("span", [
                                        _vm._v(_vm._s(item.meta.title))
                                      ])
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "el-submenu",
                            {
                              key: item.name,
                              attrs: { index: item.name || item.path }
                            },
                            [
                              _c(
                                "template",
                                { slot: "title" },
                                [
                                  item.meta && item.meta.icon
                                    ? _c("svg-icon", {
                                        attrs: { "icon-class": item.meta.icon }
                                      })
                                    : _vm._e(),
                                  item.meta && item.meta.title
                                    ? _c("span", [
                                        _vm._v(_vm._s(item.meta.title))
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._l(item.children, function(child) {
                                return child && !child.hidden
                                  ? [
                                      child.children &&
                                      child.children.length > 0
                                        ? _c(
                                            "el-submenu",
                                            {
                                              key: child.name + "1",
                                              attrs: {
                                                index: child.name || child.path
                                              }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "title" },
                                                [
                                                  child.meta && child.meta.icon
                                                    ? _c("svg-icon", {
                                                        attrs: {
                                                          "icon-class":
                                                            child.meta.icon
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  child.meta && child.meta.title
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            child.meta.title
                                                          )
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _c("sidebar-item-for-choose", {
                                                key: child.path,
                                                staticClass: "nest-menu",
                                                attrs: {
                                                  children: "children",
                                                  "is-nest": true,
                                                  route: child
                                                }
                                              })
                                            ],
                                            2
                                          )
                                        : _c(
                                            "router-link",
                                            {
                                              key: child.name,
                                              attrs: {
                                                to:
                                                  item.path +
                                                  "/" +
                                                  child.path +
                                                  (child.props !== undefined
                                                    ? "?" +
                                                      _vm.getQuery(child.props)
                                                    : "")
                                              }
                                            },
                                            [
                                              _c(
                                                "el-menu-item",
                                                {
                                                  attrs: {
                                                    index:
                                                      item.path +
                                                      "/" +
                                                      child.path
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.handleRouteLink(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  child.meta && child.meta.icon
                                                    ? _c("svg-icon", {
                                                        attrs: {
                                                          "icon-class":
                                                            child.meta.icon
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  child.meta && child.meta.title
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            child.meta.title
                                                          )
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                    ]
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                    ]
                  : _vm._e()
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }